<template>
  <b-modal
    body-bg-variant="light"
    body-text-variant="dark"
    footer-bg-variant="dark"
    footer-text-variant="light"
    footer-class="p-1"
    body-class="p-2"
    hide-header
    :hide-backdrop="backdrop === false"
    no-close-on-backdrop
    no-close-on-esc
    size="sm"
    :modal-class="exitConfirmation === false ? 'modal-confirmation' : 'exit-confirmation'"
    ref="confirmation"
    style="z-index: 10000"
  >
    <b-container fluid>
      <b-row class="mb-1 text-center">
        <b-col>{{ message }}</b-col>
      </b-row>
    </b-container>
    <template #modal-footer="{ close }">
      <div class="col-12">
        <div class="row">
          <div class="col-6 text-left">
            <b-button variant="danger" class="rounded-0" @click="_cancel">
              Nu
            </b-button>
          </div>
          <div class="col-6 text-right">
            <b-button variant="success" class="rounded-0" @click="_confirm">
              Da
            </b-button>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
function initialDataConfirm () {
  return {
    message: '',
    resolvePromise: undefined,
    rejectPromise: undefined,
    backdrop: false,
    exitConfirmation: false
  }
}
export default {
  name: 'Confirm',
  mixins: [],
  props: {},
  components: {},
  data () {
    return initialDataConfirm()
  },
  methods: {
    confirm (message, resolve) {
      this.message = message
      this.$refs.confirmation.show()
      this.resolvePromise = resolve
    },

    _confirm () {
      this.$refs.confirmation.hide()
      this.$root.$emit('hideOverlay')
      return this.resolvePromise(true)
    },

    _cancel () {
      this.$refs.confirmation.hide()
      this.$root.$emit('hideOverlay')
      return this.resolvePromise(false)
    },
    resetConfirm () {
      Object.assign(this.$data, initialDataConfirm())
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    this.$root.$on('askConfirmation', (message, resolve, exit = false, backdrop = false, overlay = false) => {
      if (overlay === true) {
        this.$root.$emit('showOverlay')
      }
      this.backdrop = backdrop
      this.exitConfirmation = exit
      this.confirm(message, resolve)
    })
  },
  beforeDestroy () {
  },
  destroyed() {
    this.$root.$off('askConfirmation')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.modal-confirmation > .modal-dialog {
  position:fixed;
  top:auto;
  right:0;
  left:0;
  bottom:0;
  width: 96vw;
}
.exit-confirmation > .modal-dialog {
  position:fixed;
  top:50%;
  width: 96vw;
}
</style>
